import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { 
  HomeIcon, CreditCardIcon, ArrowUpTrayIcon, ArrowDownTrayIcon,
  DocumentTextIcon, ChartBarIcon, UserGroupIcon, ShieldCheckIcon,
  Cog6ToothIcon, Bars3Icon, XMarkIcon, UserCircleIcon
} from '@heroicons/react/24/outline';

const Sidebar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const isAdmin = user?.role === 'admin' || user?.role === 'super_admin';

  const userLinks = [
    { to: '/dashboard', icon: HomeIcon, label: 'Dashboard' },
    { to: '/markets', icon: ChartBarIcon, label: 'Markets' },
    { to: '/deposit', icon: ArrowDownTrayIcon, label: 'Deposit' },
    { to: '/withdraw', icon: ArrowUpTrayIcon, label: 'Withdraw' },
    { to: '/mytrades', icon: ChartBarIcon, label: 'My Trades' },
    { to: '/history', icon: DocumentTextIcon, label: 'History' },
    { to: '/kyc', icon: ShieldCheckIcon, label: 'KYC' },
    { to: '/profile', icon: UserCircleIcon, label: 'Profile' }, 
    { to: '/trading', icon: ChartBarIcon, label: 'Trading' },
  ];

  const adminLinks = [
    { to: '/admin/dashboard', icon: HomeIcon, label: 'Admin' },
    { to: '/admin/kyc-review', icon: DocumentTextIcon, label: 'KYC Review' },
    { to: '/admin/withdrawals', icon: CreditCardIcon, label: 'Withdrawals' },
    { to: '/admin/trades', icon: ChartBarIcon, label: 'Enter Trade' },
    { to: '/admin/users', icon: UserGroupIcon, label: 'Users' },
  ];

  const handleLogout = () => {
    logout();
    navigate('/login');
    setIsMobileOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileOpen(!isMobileOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileOpen(false);
  };

  const MobileMenuButton = () => (
    <button
      onClick={toggleMobileMenu}
      className="fixed top-4 left-4 z-50 md:hidden bg-[#1e293b] p-2 rounded-lg border border-gray-700"
    >
      {isMobileOpen ? <XMarkIcon className="w-5 h-5" /> : <Bars3Icon className="w-5 h-5" />}
    </button>
  );

  const SidebarContent = () => (
    <div className="flex flex-col h-full">
      <div className="px-4 py-5 border-b border-gray-800">
        <h1 className="text-lg font-bold gradient-text">Coinspire</h1>
        <p className="text-[11px] text-gray-500 mt-0.5">Trading Platform</p>
      </div>
      
      <nav className="flex-1 px-3 py-3 space-y-1">
        {userLinks.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            onClick={closeMobileMenu}
            className={({ isActive }) =>
              `nav-link ${isActive ? 'active' : ''}`
            }
          >
            <link.icon className="sidebar-icon" />
            <span>{link.label}</span>
          </NavLink>
        ))}
        
        {isAdmin && (
          <>
            <div className="border-t border-gray-800 my-3"></div>
            {adminLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                onClick={closeMobileMenu}
                className={({ isActive }) =>
                  `nav-link ${isActive ? 'active' : ''}`
                }
              >
                <link.icon className="sidebar-icon" />
                <span>{link.label}</span>
              </NavLink>
            ))}
          </>
        )}
      </nav>
      
      <div className="p-3 border-t border-gray-800">
        <button
          onClick={handleLogout}
          className="logout-btn"
        >
          <Cog6ToothIcon className="sidebar-icon" />
          <span>Logout</span>
        </button>
      </div>
    </div>
  );

  return (
    <>
      <MobileMenuButton />
      
      <aside className="sidebar hidden md:block">
        <SidebarContent />
      </aside>
      
      {isMobileOpen && (
        <>
          <div 
            className="fixed inset-0 bg-black/60 z-40 md:hidden"
            onClick={closeMobileMenu}
          />
          <aside className="sidebar z-50 md:hidden open">
            <SidebarContent />
          </aside>
        </>
      )}
    </>
  );
};

export default Sidebar;